module.exports = __webpack_public_path__ + "b461a42f95ae2d1d5fa122d7a2073412.svg";